<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]="windowHash"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid m-b-lg">
    <!-- <div class="row" *ngIf="model.tipoDocumento">
      <div class="col-12">
        <b>model.tipoDocumento: </b>{{model.tipoDocumento | json}}
      </div>
    </div>
    <hr />
    <div class="row" *ngIf="model.division">
      <div class="col-12"><b>model.division: </b>{{model.division | json}}</div>
    </div>
    <hr />
    <div class="row" *ngIf="model.circuito">
      <div class="col-12"><b>model.circuito: </b>{{model.circuito | json}}</div>
    </div>
    <hr /> -->
    <ng-container *ngIf="rule; else noRule">
      <dl>
        <dt>Flujo:</dt>
        <dd> {{ procedure.definition.identifier }} - {{ procedure.definition.description }} </dd>
        <dt>Tipo Documento:</dt>
        <dd> {{ procedure.documentClass.identifier }} - {{ procedure.documentClass.name }} </dd>
        <dt>Division:</dt>
        <dd>{{ rule.division.name }}</dd>
        <dt>Fase:</dt>
        <dd>{{ rule.division.phase.description }}</dd>
        <dt>Circuito:</dt>
        <dd>{{ procedure.circuit.name }}</dd>
      </dl>
    </ng-container>
    <!-- INICIO MANUAL (SIN REGLA) pendiente mix (regla que no defina todos los necesario)-->
    <ng-template #noRule>
      <!-- TIPO DE DOCUMENTO -->
      <div class="row">
        <div class="col-12">
          <formElement [model]="model" [fieldConfig]="getBuscadorDocumentos()"
            (valueChanged)="selectDocumentClass($event)"></formElement>
        </div>
      </div>
      <!-- DIVISION -->
      <div class="row" *ngIf="model.tipoDocumento">
        <div class="col-12">
          <formElement [model]="model" [fieldConfig]="getBuscadorDivisionTree()"
            (valueChanged)="selectDivision($event)"></formElement>
          <!-- <label for="divisionesControl">2. Seleccionar división</label>
          <p-tree
            id="divisionesControl"
            [value]="rootDivision"
            selectionMode="single"
            (onNodeSelect)="selectDivision($event)"
          >
          </p-tree> -->
        </div>
      </div>
      <!-- FASE -->
      <div class="row" *ngIf="!showCircuits && phaseSearchId !== undefined && model.division && model.tipoDocumento">
        <div class="col-12">
          <formElement [model]="this" [fieldConfig]="getBuscadorFaseConfig()"></formElement>
        </div>
      </div>
      <div class="row" *ngIf="!showCircuits && phaseSearchId !== undefined && model.division && model.tipoDocumento">
        <div class="col-12 mt-2">
          <label>{{ 'BasicDocument.comments' | translate }}</label>
          <textarea maxlength="240" class="form-control" placeholder="{{ 'BasicDocument.write.comments' | translate }}"
            tabindex="4" [(ngModel)]="model.comment" name="comment"></textarea>
        </div>
      </div>
      <!-- CIRCUITO -->
      <div class="row" *ngIf="showCircuits && model.division && model.tipoDocumento">
        <div class="col-12">
          <!-- <formElement [model]="model" [fieldConfig]="getFieldConfigCircuitos()"
          (valueChanged)="loadSteps ($event.value)"></formElement> -->
          <label for="circuitosControl">{{ 'Procedures.selectCircuit' | translate }} </label>
          <p-dropdown id="circuitosControl" [options]="circuitos" [(ngModel)]="model.circuito" class="plForm-element"
            [style]="{ width: '100%' }" [ngModelOptions]="{ standalone: true }" (onChange)="loadSteps ($event.value)">
          </p-dropdown>
        </div>
      </div>
    </ng-template>
    <ng-container *ngIf="showCircuits && model.division && model.tipoDocumento && model.circuito">
      <div class="row"
        *ngIf="!model.circuito.config?.listCircuitStepDTO || model.circuito.config?.listCircuitStepDTO.length == 0">
        <div class="col-12"></div>
      </div>
      <div class="row m-b-lg"
        *ngIf="model.circuito.config?.listCircuitStepDTO && model.circuito.config?.listCircuitStepDTO.length > 0">
        <div class="col-12 m-t-md m-b-lg">
          <p-table [value]="model.circuito.config?.listCircuitStepDTO" [paginator]="false" [responsive]="true"
            class="footer-over-pagination mb-3">
            <ng-template pTemplate="header">
              <tr>
                <th class="col-icon">#</th>
                <th style="width: 100px;">Tarea</th>
                <th style="width:25%">Perfil</th>
                <th style="width:45%">Buzón</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-idx="rowIndex" let-step>
              <tr>
                <td class="col-icon">
                  <span class="badge badge-primary" style="font-size: 18px;">{{ idx + 1 }}</span>
                </td>
                <td>
                  <span class="p-column-title">Tarea</span>{{ step.typeStep }}
                </td>
                <td>
                  <span class="p-column-title">Perfil</span>{{ step.profile.description }} - {{ step.stepRol }}
                </td>
                <td>
                  <span class="p-column-title">Buzón</span>
                  <formElement [model]="step" [fieldConfig]="getBuscadorBuzonesConfig(step)"></formElement>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>
    <ng-template #noCircuit>
      <div class="row">
        <div class="col-12"> La regla no tiene circuito asociado! </div>
        <div class="col-12"> {{model.circuito | json}} </div>
      </div>
    </ng-template>
  </div>
</p-scrollPanel>